import { Card, Hyperlink } from "@ebsco-ui/ebsco-ui";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { compose } from "redux";
import { PUA_UPDATE_PATH } from "../../../constants";
import { getConfigError } from "../../store/create";
import GenericError from "../generic-error";
import PageHeader from "../page-header";
import withGdpr from "../with-gdpr";
import withSecretQuestions from "../with-secret-questions";
import AccountBenefits from "./account-benefits";
import AccountCreatedIndicator from "./account-created-indicator";
import messages from "./create-messages";
import CreateUserForm from "./create-user-form";

import "./create.scss";

const Create = ({
  intl: { formatMessage },
  signInUrl,
  createUserSuccess,
  configurationError
}) => {
  const signInUrlDefault = signInUrl || PUA_UPDATE_PATH;

  if (configurationError) {
    return <GenericError />;
  } else if (createUserSuccess) {
    return (
      <main className="create-success">
        <AccountCreatedIndicator signInUrl={signInUrlDefault} />
      </main>
    );
  } else {
    return (
      <main className="create">
        <PageHeader pageTitleText={formatMessage(messages.createYourAccount)}>
          <p className="create__account-sign-in">
            <FormattedMessage
              {...messages.alreadyHaveAnAccount}
              values={{
                a: displayLink(signInUrlDefault)
              }}
            />
          </p>
        </PageHeader>
        <Card
          className="create__card"
          border="all"
          isRounded={true}
          isRaised={true}
          isTransparent={false}
        >
          <CreateUserForm />
          <AccountBenefits />
        </Card>
      </main>
    );
  }
};

const displayLink = signInUrlDefault => msg => (
  <Hyperlink id="sign-in-link" target="_self" href={signInUrlDefault}>
    {msg}
  </Hyperlink>
);

Create.propTypes = {
  signInUrl: PropTypes.string,
  createUserSuccess: PropTypes.bool.isRequired,
  configurationError: PropTypes.object
};

const mapStateToProps = state => ({
  signInUrl: state.navigation.returnUrl,
  createUserSuccess: state.create.createUserSucess,
  configurationError: getConfigError(state)
});

export { Create };
export default compose(
  withGdpr,
  withSecretQuestions,
  injectIntl,
  connect(mapStateToProps)
)(Create);
